(ns frontend.test.field-editor.view
  (:require [common.currencies :as currencies]
            [common.localization :as loc]
            [common.schema.data-types :as data-types]
            [reagent.core :as r]
            [ui.editors.labelled-input.view :as labelled-input]
            [ui.view.page.view :as page]))

(def state (r/atom {}))

(defn view
  []
  [page/centered
   (->> data-types/zapflow-data-types
        (keys)
        (remove #{:data.type/financials :data.type/tesi-financials :data.type/tesi-financials-2
                  :data.type/text-multi :data.type/keyword-multi :data.type/url-multi
                  :data.type/email-multi :data.type/id :data.type/text :data.type/text-edn})
        (sort-by loc/tr)
        (map (fn [data-type]
               ^{:key (str data-type)}
               [:div
                [:h2 (loc/tr data-type) " < " data-type]
                [labelled-input/view
                 {:data-type data-type
                  :value     (get @state data-type)
                  :label     (str "Label for " (name data-type))
                  :options   (case data-type
                               :data.type/currency-symbol currencies/value-options
                               :data.type/keyword [{:value :key-1
                                                    :label "Key 1"}
                                                   {:value :key-2
                                                    :label "Key 2"}]
                               :data.type/ref-single [{:value 1
                                                       :label "Ref 1"}
                                                      {:value 2
                                                       :label "Ref 2"}]
                               :data.type/ref-multi (->> (range 1 10)
                                                         (map (fn [i]
                                                                {:value i
                                                                 :label (str "Ref " i)}))
                                                         (doall))
                               nil)
                  :on-change (fn [v]
                               (swap! state assoc data-type v))}]]))
        (doall))])
